import { Taf } from '@huyafed/taf-network'

/* Generated-compatible subset of GameToolServer.jce for getGameToolVersion. */
export var GameToolServer = GameToolServer || {}
export var HUYA = HUYA || {}

HUYA.UserId = function () {
  this.lUid = 0
  this.sGuid = ''
  this.sToken = ''
  this.sHuYaUA = ''
  this.sCookie = ''
  this.iTokenType = 0
  this.sDeviceInfo = ''
  this.sQIMEI = ''
}
HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid)
  this.sGuid = is.readString(1, false, this.sGuid)
  this.sToken = is.readString(2, false, this.sToken)
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA)
  this.sCookie = is.readString(4, false, this.sCookie)
  this.iTokenType = is.readInt32(5, false, this.iTokenType)
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo)
  this.sQIMEI = is.readString(7, false, this.sQIMEI)
}
HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid)
  os.writeString(1, this.sGuid)
  os.writeString(2, this.sToken)
  os.writeString(3, this.sHuYaUA)
  os.writeString(4, this.sCookie)
  os.writeInt32(5, this.iTokenType)
  os.writeString(6, this.sDeviceInfo)
  os.writeString(7, this.sQIMEI)
}
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId() }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value) }
HUYA.UserId.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def) }

GameToolServer.GetGameToolVersionReq = function () {
  this.tId = new HUYA.UserId()
  this.toolId = ''
  this.version = ''
}
GameToolServer.GetGameToolVersionReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId)
  this.toolId = is.readString(1, false, this.toolId)
  this.version = is.readString(2, false, this.version)
}
GameToolServer.GetGameToolVersionReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId)
  os.writeString(1, this.toolId)
  os.writeString(2, this.version)
}
GameToolServer.GetGameToolVersionReq.prototype._clone = function () { return new GameToolServer.GetGameToolVersionReq() }
GameToolServer.GetGameToolVersionReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value) }
GameToolServer.GetGameToolVersionReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def) }

GameToolServer.CommonResponse = function () { this.res = 0; this.msg = '' }
GameToolServer.CommonResponse.prototype.readFrom = function (is) { this.res = is.readInt32(0, false, this.res); this.msg = is.readString(1, false, this.msg) }
GameToolServer.CommonResponse.prototype.writeTo = function (os) { os.writeInt32(0, this.res); os.writeString(1, this.msg) }
GameToolServer.CommonResponse.prototype._clone = function () { return new GameToolServer.CommonResponse() }
GameToolServer.CommonResponse.prototype._write = function (os, tag, value) { os.writeStruct(tag, value) }
GameToolServer.CommonResponse.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def) }

GameToolServer.ToolVersionInfo = function () { this.version = ''; this.dataBaseUrl = '' }
GameToolServer.ToolVersionInfo.prototype.readFrom = function (is) { this.version = is.readString(0, false, this.version); this.dataBaseUrl = is.readString(1, false, this.dataBaseUrl) }
GameToolServer.ToolVersionInfo.prototype.writeTo = function (os) { os.writeString(0, this.version); os.writeString(1, this.dataBaseUrl) }
GameToolServer.ToolVersionInfo.prototype._clone = function () { return new GameToolServer.ToolVersionInfo() }
GameToolServer.ToolVersionInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value) }
GameToolServer.ToolVersionInfo.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def) }

GameToolServer.GameToolInfo = function () {
  this.toolId = ''
  this.gameId = 0
  this.toolType = 0
  this.toolName = ''
  this.toolLogo = ''
  this.pcSmallCardPic = ''
  this.pcBigCardPic = ''
  this.mobileSmallCardPic = ''
  this.mobileBigCardPic = ''
  this.platformList = new Taf.Vector(new Taf.INT32())
  this.toolMobileUrl = ''
  this.toolPcUrl = ''
  this.toolTag = new Taf.Vector(new Taf.STRING())
  this.toolDesc = ''
  this.showLaunchBtn = 0
  this.toolWebUrl = ''
  this.mobileMaskPic = ''
  this.version = ''
}
GameToolServer.GameToolInfo.prototype.readFrom = function (is) {
  this.toolId = is.readString(0, false, this.toolId)
  this.gameId = is.readInt64(1, false, this.gameId)
  this.toolType = is.readInt32(2, false, this.toolType)
  this.toolName = is.readString(3, false, this.toolName)
  this.toolLogo = is.readString(4, false, this.toolLogo)
  this.pcSmallCardPic = is.readString(5, false, this.pcSmallCardPic)
  this.pcBigCardPic = is.readString(6, false, this.pcBigCardPic)
  this.mobileSmallCardPic = is.readString(7, false, this.mobileSmallCardPic)
  this.mobileBigCardPic = is.readString(8, false, this.mobileBigCardPic)
  this.platformList = is.readVector(9, false, this.platformList)
  this.toolMobileUrl = is.readString(10, false, this.toolMobileUrl)
  this.toolPcUrl = is.readString(11, false, this.toolPcUrl)
  this.toolTag = is.readVector(12, false, this.toolTag)
  this.toolDesc = is.readString(13, false, this.toolDesc)
  this.showLaunchBtn = is.readInt32(14, false, this.showLaunchBtn)
  this.toolWebUrl = is.readString(15, false, this.toolWebUrl)
  this.mobileMaskPic = is.readString(16, false, this.mobileMaskPic)
  this.version = is.readString(17, false, this.version)
}
GameToolServer.GameToolInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.toolId); os.writeInt64(1, this.gameId); os.writeInt32(2, this.toolType); os.writeString(3, this.toolName); os.writeString(4, this.toolLogo); os.writeString(5, this.pcSmallCardPic); os.writeString(6, this.pcBigCardPic); os.writeString(7, this.mobileSmallCardPic); os.writeString(8, this.mobileBigCardPic); os.writeVector(9, this.platformList); os.writeString(10, this.toolMobileUrl); os.writeString(11, this.toolPcUrl); os.writeVector(12, this.toolTag); os.writeString(13, this.toolDesc); os.writeInt32(14, this.showLaunchBtn); os.writeString(15, this.toolWebUrl); os.writeString(16, this.mobileMaskPic); os.writeString(17, this.version)
}
GameToolServer.GameToolInfo.prototype._clone = function () { return new GameToolServer.GameToolInfo() }
GameToolServer.GameToolInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value) }
GameToolServer.GameToolInfo.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def) }

GameToolServer.GetGameToolVersionRsp = function () { this.response = new GameToolServer.CommonResponse(); this.toolInfo = new GameToolServer.GameToolInfo(); this.versionInfo = new GameToolServer.ToolVersionInfo() }
GameToolServer.GetGameToolVersionRsp.prototype.readFrom = function (is) { this.response = is.readStruct(0, false, this.response); this.toolInfo = is.readStruct(1, false, this.toolInfo); this.versionInfo = is.readStruct(2, false, this.versionInfo) }
GameToolServer.GetGameToolVersionRsp.prototype.writeTo = function (os) { os.writeStruct(0, this.response); os.writeStruct(1, this.toolInfo); os.writeStruct(2, this.versionInfo) }
GameToolServer.GetGameToolVersionRsp.prototype._clone = function () { return new GameToolServer.GetGameToolVersionRsp() }
GameToolServer.GetGameToolVersionRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value) }
GameToolServer.GetGameToolVersionRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def) }
